var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { TypeActionPlayerInfo } from "./actionPlayerInfo";
var initial = {
    adventurerLevel: 0,
    adventurerXp: Long.ZERO,
    buff: [],
    coopId: Long.ZERO,
    level: 1,
    name: "",
    playerId: Long.ZERO,
    profilePictureId: 1,
    research: [],
    xp: Long.ZERO,
};
export var reducerPlayerInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionPlayerInfo.Received: {
            if (action.playerInfo != undefined) {
                return __assign({}, state, action.playerInfo);
            }
            return state;
        }
        case TypeActionPlayerInfo.UpdateCoopInfo: {
            return __assign({}, state, { coopId: action.coopId });
        }
        case TypeActionPlayerInfo.AddXp: {
            return __assign({}, state, { xp: state.xp.add(action.xp) });
        }
        case TypeActionPlayerInfo.AddLevel: {
            return __assign({}, state, { level: state.level + action.level });
        }
        case TypeActionPlayerInfo.ChangeName: {
            return __assign({}, state, { name: action.name });
        }
        case TypeActionPlayerInfo.ChangeProfilePicture: {
            return __assign({}, state, { profilePictureId: action.id });
        }
        case TypeActionPlayerInfo.AddBuff: {
            var updatedBuffs_1 = state.buff.slice();
            action.buff.forEach(function (newBuff) {
                var oldBuffIndex = updatedBuffs_1.findIndex(function (oldBuff) { return oldBuff.id === newBuff.id; });
                if (oldBuffIndex !== -1) {
                    updatedBuffs_1[oldBuffIndex] = newBuff;
                }
                else {
                    updatedBuffs_1.push(newBuff);
                }
            });
            return __assign({}, state, { buff: updatedBuffs_1 });
        }
        case TypeActionPlayerInfo.RemoveBuff: {
            var newBuffs_1 = [];
            state.buff.forEach(function (buff) {
                var found = action.buff.some(function (actionBuff) { return actionBuff.id === buff.id; });
                if (!found) {
                    newBuffs_1.push(buff);
                }
            });
            return __assign({}, state, { buff: newBuffs_1 });
        }
        default: {
            return state;
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player/reducerPlayerInfo.ts
// module id = 2539
// module chunks = 3